module.exports = __webpack_public_path__ + "static/media/old spw-global-high-quality-i.21d11925.csv";